closedLoansItemController.$inject = ['LKConfig'];
export default function closedLoansItemController(LKConfig) {
    var ctrl = this;
    ctrl.$onInit = function() {
        ctrl.catalogid = LKConfig.catalogid;
    };
    ctrl.select = function() {
        ctrl.onSelect({item: ctrl.item});
    };
}
